<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-card">
        <div class="md-card-header md-card-header-icon md-card-header-rose">
          <div class="card-icon">
            <i class="material-icons">settings</i>
          </div>
          <h4 class="title">{{ $t("myProfile") }}</h4>
        </div>
        <div class="md-card-content">
          <!-- Loading state -->
          <ContentSkeleton v-if="loading" variant="form" :rows="6" />

          <!-- Error state -->
          <div v-else-if="error" class="alert alert-danger">
            {{ error }}
          </div>

          <!-- Profile form -->
          <outlook-profile-connect v-if="isOutlookModuleActive" />
          <EditUserForm
            v-if="useredit"
            :user="useredit"
            :isOwnProfile="true"
            :hideRole="true"
            :roles="[]"
            @user-updated="handleUserUpdated"
          />
        </div>
      </div>

      <div class="md-card" v-if="role == 'gym'">
        <div class="md-card-header md-card-header-icon md-card-header-rose">
          <div class="card-icon">
            <i class="material-icons">payment</i>
          </div>
          <h4 class="title">Mis pagos</h4>
        </div>
        <div class="md-card-content">
          <table class="table">
            <thead>
              <tr>
                <th>Monto</th>
                <th>Fecha</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payments" :key="item._id">
                <td>{{ item.amount }}$</td>
                <td>{{ item.createdAt }}</td>
                <td>{{ item.status }}</td>
              </tr>
            </tbody>
          </table>

          <div
            v-if="payments.length == 0"
            class="w-100 text-center customborder"
          >
            <h5 class="text-secondary p-4">{{ $t("nothingtosee") }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  saveAction,
  getSettingsAction,
  getAllPaymentsAction,
} from "@/pages/Auth/actions";
import Swal from "sweetalert2";
import { Stripe } from "@/pages";
import permissionsMixin from "@/mixins/permissionsMixin";
import { getPriceAction, oauthAction } from "@/pages/MercadoPago/actions";
import NewUserForm from "@/pages/Dashboard/Pages/UserProfile/NewUserForm.vue";
import { getMyProfileAction } from "@/pages/Users/actions";
import { wencesApi } from "@/api/wencesApi";
import EditUserForm from "@/components/users/EditUserForm.vue";
import OutlookProfileConnect from "@/modules/outlook_module/components/OutlookProfileConnect.vue";
import { OUTLOOK_MODULE_NAME } from "@/modules/outlook_module";
import ContentSkeleton from "@/components/common/ContentSkeleton.vue";

export default {
  name: "Settings",
  components: {
    Stripe,
    NewUserForm,
    EditUserForm,
    OutlookProfileConnect,
    ContentSkeleton,
  },
  mixins: [permissionsMixin],

  props: {
    dashboard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      role: false,
      nameBusiness: "",
      emailBusiness: "",
      currency: "",
      waitingDays: 10,
      useredit: false,
      register: true,
      currencyPosition: "",
      subdomain: "",
      payments: [],
      currencyOptions: [],
      loading: false,
      error: null,
      activeModules: [],
    };
  },

  computed: {
    isOutlookModuleActive() {
      return this.activeModules.some(
        (m) => m.name === OUTLOOK_MODULE_NAME && m.isActive !== false
      );
    },
    currencySymbol() {
      const selectedCurrency = this.currencyOptions.find(
        (option) => option.value === this.currency
      );
      return selectedCurrency ? selectedCurrency.symbol : "";
    },
  },

  async created() {
    this.getMyProfile();
    try {
      const { data } = await wencesApi.get("/api/modules/active");
      this.activeModules = data?.modules || data || [];
    } catch (_) {
      this.activeModules = [];
    }
    this.currencyOptions = this.$currencies;
    this.subdomain = window.location.hostname;
    this.role = localStorage.getItem("role");
    const mercadoapagooauth = localStorage.getItem("mercadoapagooauth");
    if (
      this.$route.path == "/mercadopago/confirm" &&
      this.$route.query.code &&
      this.$route.query.state
    ) {
      const state = this.$route.query.state;
      if (mercadoapagooauth == state) {
        this.registerToken();
      }
    }

    if (this.role == "gym") {
      const response = await getAllPaymentsAction();
      this.payments = response.data;
    }
  },

  methods: {
    async getMyProfile() {
      try {
        this.loading = true;
        this.error = null;
        const response = await getMyProfileAction();
        if (response.ok) {
          this.useredit = response.data;
        } else {
          this.error = response.message || "Error al cargar el perfil";
        }
      } catch (error) {
        console.error("Error loading profile:", error);
        this.error = "Error al cargar el perfil del usuario";
      } finally {
        this.loading = false;
      }
    },
    async registerToken() {
      await oauthAction(this.$route.query.code);
    },

    userCreated(event) {
      Swal.fire({
        title: this.$tn("success"),
        icon: "success",
        confirmButtonText: "OK",
      });
    },

    handleUserUpdated(updatedUser) {
      this.useredit = updatedUser;
      // Actualizar el localStorage si es necesario
      if (updatedUser.name) {
        localStorage.setItem("userName", updatedUser.name);
      }
    },
    async fetchBusinessData() {
      try {
        const response = await getSettingsAction();
        const data = response.result;
        this.emailBusiness =
          data.email === "contact@rodisio.com" ? "" : data.email || "";
        this.nameBusiness = data.name || "";
        this.currency = data.currency || "usd"; // valor predeterminado
        this.currencyPosition = data.currencyPosition || "after";
        if (data.waitingDays) {
          this.waitingDays = data.waitingDays;
        }
        if (data.register) {
          this.register = data.register;
        }
      } catch (error) {
        console.error("Error fetching business data:", error);
      }
    },
    async saveSettings() {
      if (this.isDemo()) {
        return;
      }

      const data = {
        name: this.nameBusiness,
        email: this.emailBusiness,
        currency: this.currency,
        currencyPosition: this.currencyPosition,
        waitingDays: this.waitingDays,
        register: this.register,
      };

      try {
        await saveAction(data);
        Swal.fire({
          title: this.$tn("success"),
          text: this.$tn("business_info_updated"),
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error("Error saving business data:", error);
        Swal.fire({
          title: this.$tn("error"),
          text: this.$tn("error_updating_business_info"),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
  },

  async mounted() {
    this.fetchBusinessData();
  },
};
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.form-control-static {
  margin-top: 6px;
}
</style>
